export default [
  {
    path: '/shipping/inbound-awaiting-waybill',
    name: 'shipping-inbound-awaiting-waybill',
    component: () => import('@/views/modules/shipping/inboundAwaitingWaybill'),
    meta: {
      requiresAuth: true,
      title:'Awaiting Waybill',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Inbound Awaiting Waybill' }
      ]
    },
    children:[
      {
        path: '/shipping/inbound-waybill-create/:id/create',
        props: true,
        name: 'shipping-inbound-waybill-create',
        component: () => import('@/views/modules/shipping/inboundWaybillCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Inbound Waybill Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Inbound Awaiting Waybills', link: '/shipping/inbound-awaiting-waybill' },
            { text: 'Create' }
          ]
        }
      },
    ]
    
  }, 
  {
    path: '/shipping/inbound',
    name: 'shipping-inbound',
    component: () => import('@/views/modules/shipping/inbound'),
    meta: {
      requiresAuth: true,
      title:'Inbound',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Inbound' }
      ]
    },
    children:[
      {
        path: '/shipping/inbound-received-create/:id/create',
        props: true,
        name: 'shipping-inbound-received-create',
        component: () => import('@/views/modules/shipping/inboundReceivedCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Inbound Received',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Inbound', link: '/shipping/inbound' },
            { text: 'Received' }
          ]
        }
      },
    ]
    
  }, 
  {
    path: '/shipping/outbound-awaiting-waybill',
    name: 'shipping-outbound-awaiting-waybill',
    component: () => import('@/views/modules/shipping/outboundAwaitingWaybill'),
    meta: {
      requiresAuth: true,
      title:'Outbound Awaiting Waybill',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Outbound Awaiting Waybill' }
      ]
    },
    children:[
      {
        path: '/shipping/outbound-waybill-create/:id/create',
        props: true,
        name: 'shipping-outbound-waybill-create',
        component: () => import('@/views/modules/shipping/outboundWaybillCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Outbound Waybill Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Outbound Awaiting Waybills', link: '/shipping/outbound-awaiting-waybill' },
            { text: 'Create' }
          ]
        }
      },
    ]
    
  }, 

  {
    path: '/shipping/outbound',
    name: 'shipping-outbound',
    component: () => import('@/views/modules/shipping/outbound'),
    meta: {
      requiresAuth: true,
      title:'Outbound',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Outbound' }
      ]
    },
    children:[
      {
        path: '/shipping/outbound-delivered-create/:id/create',
        props: true,
        name: 'shipping-outbound-delivered-create',
        component: () => import('@/views/modules/shipping/outboundDeliveredCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Outbound Delivered',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Outbound', link: '/shipping/outbound' },
            { text: 'Delivered' }
          ]
        }
      },
    ]
    
  }, 

  {
    path: '/shipping/handoff',
    name: 'shipping-handoff',
    component: () => import('@/views/modules/shipping/handoff'),
    meta: {
      requiresAuth: true,
      title:'Handoff',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Handoff' }
      ]
    },
    children:[
      {
        path: '/shipping/handoff-handed-off-create/:id/create',
        props: true,
        name: 'shipping-handoff-handed-off-create',
        component: () => import('@/views/modules/shipping/handoffHandedOffCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Handed Off Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Handoff', link: '/shipping/handoff' },
            { text: 'Handed Off' }
          ]
        }
      },
    ]
    
  }, 


  {
    path: '/shipping/manifests',
    name: 'shipping-manifests',
    component: () => import('@/views/modules/shipping/manifests'),
    meta: {
      requiresAuth: true,
      title:'Manifests',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Manifests' }
      ]
    },
    children:[
      {
        path: '/shipping/manifests/create',
        props: true,
        name: 'shipping-manifests-create',
        component: () => import('@/views/modules/shipping/manifestCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Manifest Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Manifests', link: '/shipping/manifests' },
            { text: 'Manifest Create' }
          ]
        }
      },
      {
        path: '/shipping/manifests/:id/jobs',
        props: true,
        name: 'shipping-manifests-jobs',
        component: () => import('@/views/modules/shipping/manifestJobs'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Manifest Jobs',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Manifests', link: '/shipping/manifests' },
            { text: 'Manifest Jobs' }
          ]
        }
      },
      {
        path: '/shipping/manifests/:id/show',
        props: true,
        name: 'shipping-manifests-show',
        component: () => import('@/views/modules/shipping/manifestShow'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Manifest Jobs',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Manifests', link: '/shipping/manifests' },
            { text: 'Manifest Jobs' }
          ]
        }
      },
    ]
  }
 
]